<template>
  <div class="home" :style="bgStyles">
    <img :src="`/images/${imgIndex}.jpg`" />
    <img class="blur" :src="`/images/${imgIndex}.jpg`" />
    <input
      :style="bgStyles"
      v-model="hue"
      type="range"
      step="0.001"
      min="0"
      max="1"
    />
  </div>
</template>

<script>
export default {
  name: "Home",
  computed: {
    imgIndex() {
      let index = this.hues.findIndex((h) => this.hue <= h);
      return index === -1 ? this.hues.length - 1 : index;
    },
    bgStyles() {
      return { backgroundColor: `hsl(${this.hue * 360}, 50%, 50%)` };
    },
  },
  data() {
    return {
      hue: 0,
      hues: [
        0.0, 0.0001, 0.0032679738562091574, 0.0035842293906810005,
        0.006666666666666672, 0.008771929824561412, 0.009803921568627453,
        0.01075268817204302, 0.011627906976744188, 0.011695906432748537,
        0.01254480286738352, 0.014999999999999994, 0.01612903225806452,
        0.017730496453900717, 0.018518518518518528, 0.020050125313283207,
        0.022346368715083793, 0.02247191011235955, 0.02314814814814814,
        0.02314814814814814, 0.02380952380952382, 0.02511415525114156,
        0.025316455696202538, 0.029487179487179493, 0.03211009174311926,
        0.03231292517006803, 0.0345679012345679, 0.034615384615384624,
        0.03571428571428572, 0.03921568627450981, 0.041666666666666664,
        0.04199475065616798, 0.04597701149425287, 0.0471976401179941,
        0.05000000000000001, 0.051724137931034475, 0.05319148936170213,
        0.05376344086021506, 0.05555555555555556, 0.057291666666666664,
        0.05769230769230769, 0.05782312925170069, 0.059523809523809514, 0.06,
        0.06122448979591836, 0.06172839506172839, 0.06209150326797386, 0.0625,
        0.0632183908045977, 0.0632603406326034, 0.06451612903225806,
        0.06512141280353201, 0.06535947712418301, 0.06572769953051644,
        0.06642512077294686, 0.06756756756756756, 0.0683453237410072,
        0.06888888888888889, 0.06896551724137932, 0.06976744186046512,
        0.07017543859649122, 0.07051282051282053, 0.0712962962962963,
        0.0720164609053498, 0.07456140350877193, 0.0749063670411985,
        0.07575757575757576, 0.07608695652173914, 0.07657657657657657,
        0.07679738562091504, 0.07692307692307693, 0.07698815566835872,
        0.07777777777777778, 0.0790960451977401, 0.07916666666666666,
        0.08333333333333333, 0.08455882352941176, 0.08533333333333333,
        0.08801498127340823, 0.08814814814814816, 0.09070294784580497,
        0.09234234234234234, 0.12037037037037036, 0.13410852713178295,
        0.16944444444444443, 0.20325203252032523, 0.2045454545454545,
        0.23563218390804597, 0.24393939393939398, 0.27956989247311825,
        0.3064516129032258, 0.40990990990990994, 0.44252873563218387,
        0.4489247311827957, 0.4696969696969697, 0.525, 0.5317460317460317,
        0.543859649122807, 0.54421768707483, 0.548076923076923,
        0.5490196078431372, 0.5537037037037037, 0.5565610859728506,
        0.5728155339805826, 0.5745614035087719, 0.5777777777777778,
        0.5784313725490197, 0.5787878787878787, 0.5791666666666666,
        0.5800000000000001, 0.5810397553516821, 0.5833333333333334,
        0.584192439862543, 0.5845588235294118, 0.5855855855855855,
        0.5866666666666666, 0.5878378378378378, 0.5899470899470899,
        0.5938967136150235, 0.595959595959596, 0.5966666666666667,
        0.5970873786407767, 0.5973451327433628, 0.6008771929824562,
        0.6014492753623188, 0.6028985507246377, 0.6064814814814815,
        0.6147798742138365, 0.6182795698924731, 0.6228070175438596,
        0.6258503401360543, 0.6290322580645161, 0.6305220883534136,
        0.6356589147286821, 0.6371527777777778, 0.6396396396396397,
        0.6451612903225806, 0.6504629629629629, 0.6549019607843137,
        0.6698717948717948, 0.6754385964912281, 0.6759259259259259,
        0.6762820512820512, 0.6762820512820512, 0.677536231884058, 0.68, 0.6875,
        0.6904761904761906, 0.6929824561403509, 0.6957671957671958,
        0.6969696969696969, 0.6979166666666666, 0.7272727272727272,
        0.7318840579710145, 0.7447916666666666, 0.75, 0.7585669781931464,
        0.7619047619047619, 0.762962962962963, 0.7638888888888888,
        0.7676767676767677, 0.7795698924731184, 0.7901234567901234,
        0.7916666666666666, 0.8009708737864077, 0.8091397849462365,
        0.8190476190476191, 0.8290598290598291, 0.8717948717948718, 0.925,
        0.9341085271317829, 0.9461942257217848, 0.95, 0.9623655913978495,
        0.9673659673659674, 0.9748427672955975, 0.9818181818181818,
        0.986449864498645, 0.9895833333333334, 0.9905149051490515,
        0.9965277777777778, 0.9966996699669967,
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.home {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
img {
  max-height: 90%;
  max-width: 90%;
  z-index: 50;
}

input {
  position: absolute;
  left: 50%;
  bottom: 5%;
  transform: translateX(-50%);
  z-index: 100;
  background-color: #9a905d;
  appearance: none;
  border-radius: 20px;
  border: 4px solid white;
  width: 70%;
  max-width: 500px;

  &::-webkit-slider-thumb {
    border: none;
    background: white !important;
    appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 100%;
  }
  &::-moz-range-thumb {
    border: none;
    background: white !important;
    appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 100%;
  }
  &::-ms-thumb {
    border: none;
    background: white !important;
    appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 100%;
  }
}

.blur {
  min-width: 100%;
  max-width: auto;
  max-height: auto;
  min-height: 100%;
  object-fit: cover;
  filter: blur(100px);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 25;
  right: 0;
  bottom: 0;
  opacity: 0.8;
}
</style>
